module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_7016.8a575706.png";